import React from 'react';
import ConnectWalletButton from './Thirdweb/ConnectWalletButton';
import { FiMenu, FiSearch } from 'react-icons/fi';

const Header = (props: {
  sidebarOpen: string | boolean | undefined;
  setSidebarOpen: (arg0: boolean) => void;
}) => {
  return (
    <header className="sticky top-0 z-40 w-full backdrop-blur-lg">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16 gap-4">
          
          {/* Left Section: Menu Button (Mobile) and Logo/Branding */}
          <div className="flex items-center gap-4">
            <button
              aria-controls="sidebar"
              onClick={(e) => {
                e.stopPropagation();
                props.setSidebarOpen(!props.sidebarOpen);
              }}
              className="lg:hidden p-2 text-gray-600 rounded-md hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:text-gray-300 dark:hover:bg-gray-800"
            >
              <FiMenu className="w-5 h-5" />
            </button>
            
            {/* Optional: Add your logo/branding here */}
            {/* <div className="hidden sm:block font-semibold text-gray-800 dark:text-white">
              YourBrand
            </div> */}
          </div>

          {/* Middle Section: Search Bar */}
          <div className="flex-1 max-w-2xl mx-4">
            <form className="relative">
              <input
                type="text"
                placeholder="Search..."
                className="w-full px-4 py-2 rounded-full bg-gray-100 text-gray-900 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:bg-gray-800 dark:text-white dark:placeholder-gray-400"
              />
              <button
                type="submit"
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                aria-label="Search"
              >
                <FiSearch className="w-5 h-5" />
              </button>
            </form>
          </div>

          {/* Right Section: Connect Wallet Button */}
          <div className="flex items-center justify-end">
            <ConnectWalletButton />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;









